export enum UserRole {
  ADMIN = "ROLE_ADMIN",
}

export enum RoleTypes {
  ROLE_ADMIN = "Superadmin",
  ROLE_CLIENT_ADMIN = "Admin",
  ROLE_CLIENT_USER = "User",
}
